import { FolderOutlined } from '@ant-design/icons';

import FolderDashedOutlinedIcon from '@/assets/icons/FolderDashedOutlinedIcon';
import { Flex } from '@/components/base';
import SelectModal from '@/components/Select/SelectModal';
import type { BaseSelectModalProps } from '@/components/Select/types';
import Typo from '@/components/Typography/Typo';
import useColor from '@/hooks/domain/useColor';

import type { Dashboard2FolderT } from '../../types';

type Props = BaseSelectModalProps & {
  onSelect: (alias: string) => void;
  folders?: Dashboard2FolderT[];
  currentFolder?: string;
};

const DashboardFolderSelectModal = (props: Props) => {
  const { onSelect, folders, ...rest } = props;
  const color = useColor();

  return (
    <SelectModal
      {...rest}
      searchOptions={{
        enable: true,
      }}
      onSelect={(key) => props.onSelect(key as string)}
      name={props.name}
      width="320px"
      value={null}
      mapper={(op) => {
        return (
          <Flex a="center" g={8} key={op.value}>
            {op.value === 'all' ? (
              <FolderDashedOutlinedIcon
                fill={color.gray600}
                width={16}
                height={16}
              />
            ) : (
              <FolderOutlined />
            )}
            <Typo type="body2" multilineEllipsis={1}>
              {op.searchName}
            </Typo>
          </Flex>
        );
      }}
      data={[
        {
          searchName: 'No folder',
          value: 'all',
        },
        ...(folders?.map((folder) => {
          return {
            searchName: folder.name,
            value: folder.alias,
          };
        }) || []),
      ]}
    />
  );
};

export default DashboardFolderSelectModal;
